window.addEventListener("load", function() {
  var formElemSection = document.querySelector('.contact-form'),
    formElemHeight = formElemSection ? formElemSection.offsetHeight : 0;

  // load recaptcha JS after page load 
  if (formElemHeight) {
    document.addEventListener('click', loadRecaptchaForForm);
  }

  function loadRecaptchaForForm() {
    if (typeof grecaptcha === 'undefined') {
      var scriptElm = document.createElement('script');
      scriptElm.setAttribute('id', 'recaptcha-js');
      scriptElm.setAttribute('type', 'text/javascript');
      scriptElm.setAttribute('src', 'https://www.google.com/recaptcha/api.js?ver=1.0');
      scriptElm.setAttribute('defer', 'defer');
      document.body.appendChild(scriptElm);
    }
  }
});

var csrf_token,
  ContactForm = {},
  checkEmailValidation = false,
  mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;

var formElem = document.querySelector('#hero-contact-form');
ContactForm.formObj = document.getElementById('hero-contact-form');
ContactForm.formObjError = document.querySelector(".contact-form");
ContactForm.nameField = document.getElementById("form-name");
ContactForm.emailField = document.getElementById("form-email");
ContactForm.messageField = document.getElementById("form-message");
ContactForm.companyField = document.getElementById("form-company");
ContactForm.requestType = document.getElementById("request_type");
ContactForm.utf8 = document.getElementById("utf_no");
ContactForm.authenticity = document.getElementById("authenticity_token");
ContactForm.contactformSendEmail = document.getElementById("form-send-email");
ContactForm.contactFormCaptcha = document.getElementById("contactformcaptcha");
ContactForm.queryType = document.getElementById("form-query-type");
ContactForm.interactedWithDGForm = true;

/*
* Get Query Params from JS because WPEngine remove utm_* and gclid from GET object.
* Ref : https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
*/
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

document.getElementById("payload_utm_campaign").value = getParameterByName('utm_campaign');
document.getElementById("payload_utm_adgroup").value = getParameterByName('utm_adgroup');
document.getElementById("payload_gclid").value = getParameterByName('gclid');
document.getElementById("payload_utm_source").value = getParameterByName('utm_source');

var HeroSalesContact = (function(csrfToken, ContactForm) {
  return {
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields,
    setCsrfToken: setCsrfToken
  };

  function init() {

    var grecaptchaResponse = grecaptcha.getResponse();

    var form_requestHeader = {
      "X-CSRF-Token" : csrfToken,
      "content-type" : "application/x-www-form-urlencoded; charset=UTF-8" // Setting content type.
    }

    var form_data = {
      name: document.getElementById("form-name").value, 
      email: document.getElementById("form-email").value,
      query_type: ContactForm.queryType = document.getElementById("form-query-type").value,
      message: document.getElementById("form-message").value,
      company: document.getElementById("form-company").value,
      send_email: document.getElementById("form-send-email").value,
      authenticity_token: document.getElementById("authenticity_token").value, 
      utf8: document.getElementById("utf_no").value, 
      request_type: document.getElementById("request_type").value,
      utm_campaign: document.getElementById("payload_utm_campaign").value,
      utm_adgroup: document.getElementById("payload_utm_adgroup").value,
      gclid: document.getElementById("payload_gclid").value,
      utm_source: document.getElementById("payload_utm_source").value,
      page_url : window.location.href,
      cta_ref: getParameterByName('ref'),
      "g-recaptcha-response": grecaptchaResponse,
      ga_cid: bsLib.GAClientID(),
      source: "wp_form",
      utm_campaigncode: document.querySelector('[name="sfdc_utm_campaigncode"]').value.trim(),
      additional_notes: document.querySelector('[name="additional_notes"]').value.trim(),
      primary_product: document.querySelector('[name="primary_product"]').value.trim(),
      secondary_product: document.querySelector('[name="secondary_product"]').value.trim(),
      previous_page_url: (document.referrer !== '') ? document.referrer : 'organic',
      lead_source: "Contact Sales Form",
      check_email_domain: true
    }

    var form_success = function(data) {
      var dataRequest = bsLib.JSONParse(data.response);
      if (dataRequest.success === true) {
        //revsure form tracking code on success
        if (typeof window.rudderanalytics !== "undefined") {
          window.rudderanalytics.identify(form_data.email, {email: form_data.email, name: form_data.name, company: form_data.company});
          window.rudderanalytics.track("Form Submission - Contact Sales DG Form");
        }

        //common room form tracking code on success
        if (typeof window.signals !== 'undefined') {
          window.signals.identify({email: demoChatInfo.emailId, name: demoChatInfo.name});
        }

        var modalContainer = document.querySelector(".thank-you-modal"),
        modal = new tingle.modal({
          cssClass: ["hero-unit-form"],
          onClose: function() {
            modal.destroy();
          }
        });
        modal.setContent(modalContainer.innerHTML);
        modal.open();
      
        _afterSubmitSuccess();
        _logFormSubmit("FormSubmitSuccess");
      } else {
        if (dataRequest.field == 'business_email') {
          ContactForm.emailField.classList.add("error-border");
          if (ContactForm.emailField.parentNode.getElementsByClassName("error-message").length === 0) {
            var parentElement = ContactForm.emailField.parentElement;
              if (parentElement && parentElement.querySelector(".email-notify-msg")) {
                  parentElement.querySelector(".email-notify-msg").classList.add("hide");
              }
            ContactForm.emailField.insertAdjacentHTML('afterend', '<span class="error-message" id= "email-error">' + dataRequest.message + '</span>');
          }
          var submitBtn = document.getElementById("csf-submit-btn");
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
            submitBtn.value = submitBtn.dataset.valueText;
          }
          grecaptcha.reset();
          checkEmailValidation = true;
        }
        _logFormSubmit("FormSubmitError");
        console.error("form success failed");
      }
      
    };

    var form_error = function() {
      _logFormSubmit("FormSubmitError");
    };

    // xhr request for sending form data
    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/contact",
      form_data,
      false,
      form_requestHeader,
      form_success,
      form_error
    );
  }

  function setCsrfToken() {
    // XHR request for user token
    if (!csrf_token) {
      // XHR request for user token
      bsLib.ajax(
        "GET",
        bsLib.railsHost() + "/user/token.json",
        {},
        false,
        {},
        // Success message for user token.
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);
          ContactForm.authenticity.value = dataRequest.csrf_token;
          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        },
        // Custom Error message for user token.
        function() {
          return Messages.salesAndSupportPage.invalidUserToken;
        }
      );
    } else if (!csrfToken) {
      csrfToken = csrf_token;
    }
  }

  function _validateFields() {
    var formValid = true,
    namerError = document.getElementById("name-error"),
    emailError = document.getElementById("email-error"),
    messageError = document.getElementById("message-error"),
    companyError = document.getElementById("company-error"),
    recaptchaError = document.getElementById("recaptcha-error"),
    grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';

    //set csrf token
    setCsrfToken();

    if (ContactForm.nameField.value.length === 0) {
      formValid = _showError(
        ContactForm.nameField,
        namerError,
        'name-error',
        Messages.salesAndSupportPage.invalidName
      );
    } else {
      ContactForm.nameField.classList.remove("error-border");
      if (namerError) {
        namerError.remove();
      }
    }

    //remove existing error
    if (emailError) {
      emailError.remove();
    }
    
    if (ContactForm.emailField.value == "") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.noemail
      );
    } else if (!ContactForm.emailField.value.match(mailformat)) {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.invalidEmail
      );
    } else if (ContactForm.emailField.dataset.notvalid === "1") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.invalidEmail
      );
    } else {
      ContactForm.emailField.classList.remove("error-border");
      if (emailError) {
        emailError.remove();
      }
    }

    if (ContactForm.messageField.value.length === 0) {
      formValid = _showError(
        ContactForm.messageField,
        messageError,
        'message-error',
        Messages.salesAndSupportPage.invalidMessage
      );
    } else {
      ContactForm.messageField.classList.remove("error-border");
      if (messageError) {
        messageError.remove();
      }
    }

    if (ContactForm.companyField.value.length === 0) {
      formValid = _showError(
        ContactForm.companyField,
        companyError,
        'company-error',
        Messages.salesAndSupportPage.noCompanyName
      );
    } else {
      ContactForm.companyField.classList.remove("error-border");
      if (companyError) {
        companyError.remove();
      }
    }

    if (grecaptchaResponse.length === 0) {
      formValid = _showError(
        ContactForm.contactFormCaptcha,
        recaptchaError,
        "recaptcha-error",
        Messages.salesAndSupportPage.noRecaptcha
      );
    } else {
      ContactForm.contactFormCaptcha.classList.remove("error-border");
      if (recaptchaError) {
        recaptchaError.remove();
      }
    }

    return formValid;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);

    var eventName;
    switch (fieldName.getAttribute("name")) {
      case "name":
        eventName = "CsfInteractedWithNameField";
        break;
      case "email":
        eventName = "CsfInteractedWithEmailField";
        break;
      case "message":
        eventName = "CsfInteractedWithMessageField";
        break;
      case "company":
        eventName = "CsfInteractedWithCompanyField";
        break;
      default:
      // DO nothing
    }

    if (fieldName.getAttribute("id") == "contactformcaptcha") {
      eventName = "CsfInteractedWithCaptcha";
    }

    if (eventName) {
      window.hasOwnProperty('Amplitude') ? Amplitude.logEvent(eventName, {
        InvalidInput: true,
        message: errorMessage
      }) : '';
    }
  }

  function _afterSubmitSuccess() {
    //linkedIn Pixel
    if (window.lintrk !== undefined) {
      window.lintrk('track', {conversion_id: 9342705});
    }

    resetForm();
  }

  function resetForm() {
    ContactForm.formObj.reset(); //Reset form

    if (
      ContactForm.contactFormCaptcha && typeof grecaptcha !== "undefined"
    ) {
      grecaptcha.reset();
    }
  }

  function _logFormSubmit(status) {
    var data = {};
    var queryType = document.getElementById("form-query-type").getAttribute("data-query-text"),
        queryVal = document.getElementById("form-query-type").getAttribute("value");
    data.experiment = "false";
    data[status] = true;
    data.QueryTypeSubmitted = queryType ? queryType : "No query type";
    WebEventTracker.logEvent(EDS.webEvents, "SubmitDGContactForm", data);
    if (typeof ga !== "undefined") {
      ga('browserstack.send', 'event', {
        'eventCategory': 'Contact', 'eventAction': 'CtaClick', 'eventLabel': 'Submit', 'eventValue' : queryVal 
      });
    }
  }
})(csrf_token, ContactForm);

//Interact with google captcha
function InteractWithContactFormCaptcha() {
  window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("CsfInteractedWithCaptcha", {}) : '';
  if (ContactForm.InteractedwithDGForm) {
    window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("InteractedWithDGForm", {}) : '';
    ContactForm.InteractedwithDGForm = false;
  }
}

function InteractWithContactFormCaptcha() {
  WebEventTracker.logEvent(EDS.webEvents, "CsfInteractedWithCaptcha", {
    field: "captcha",
    action: "click"
  });
}

document.addEventListener('DOMContentLoaded', function () {

  function intereactedWithFormField(eventname) {
    window.hasOwnProperty('Amplitude') ? Amplitude.logEvent(eventname, {}) : '';
    if (ContactForm.InteractedwithDGForm) {
      window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("InteractedWithDGForm", {}) : '';
      ContactForm.InteractedwithDGForm = false;
    }
  }

  // email blur validation
  if (ContactForm.emailField) {
    ContactForm.emailField.addEventListener("blur", function(event) {
      var validEmail = true,
        that = this,
        submitBtn = document.getElementById("csf-submit-btn"),
        emailError = document.getElementById("email-error");
      if (checkEmailValidation) {
        return;
      }
      //false valid dataset
      that.dataset.notvalid = "0";

      //remove existing error
      if (emailError) {
        emailError.remove();
      }

      if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
        validEmail = false;
        
        that.classList.add("error-border");
        that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + (that.value.length == 0 ? Messages.salesAndSupportPage.noemail : Messages.salesAndSupportPage.invalidEmail) + '</span>');
      } else {
        that.classList.remove("error-border");
      }

      if (validEmail) {
        //Disable submit button
        if (submitBtn) {
          submitBtn.setAttribute("disabled", "disabled");
          submitBtn.dataset.valueText = submitBtn.value;
          submitBtn.value = Messages.salesAndSupportPage.validateText;
        }

        // check csrf token value
        if (!csrf_token) {
          HeroSalesContact.setCsrfToken();
        }
        
        bsLib.ajax(
          "GET",
          bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value),
          {},
          true,
          {
            "X-CSRF-Token": csrf_token,
            "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
          },
          function(data) {
            var dataRequest = bsLib.JSONParse(data.response);

            //remove disable
            if (submitBtn) {
              submitBtn.removeAttribute("disabled");
              submitBtn.value = submitBtn.dataset.valueText;
            }

            if (dataRequest.valid === false) {
              that.dataset.notvalid = "1";

              that.classList.add("error-border");
              if (that.parentNode.getElementsByClassName("error-message").length === 0) {
                that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
              }
            }
          },
          function() {}
        );
      }
    });
  }

  //Interacted with fields
  ContactForm.nameField.addEventListener('blur', function (event) {
    intereactedWithFormField("CsfInteractedWithNameField");
  });

  ContactForm.emailField.addEventListener('blur', function (event) {
    intereactedWithFormField("CsfInteractedWithEmailField");
  });

  ContactForm.messageField.addEventListener('blur', function (event) {
    intereactedWithFormField("CsfInteractedWithMessageField");
  });

  ContactForm.companyField.addEventListener('blur', function (event) {
    intereactedWithFormField("CsfInteractedWithCompanyField");
  });

  //Header Section Link Click event
  var headerAnchor = document.querySelector('.header-habitat').getElementsByTagName("a");
  Array.prototype.forEach.call(headerAnchor, function (singletxt) {
    singletxt.addEventListener('click', function (event) {
      var txt = singletxt.textContent;
      window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("CsfInteractedWithHeaderLink", { Link: txt }) : '';
    });
  });

  //Footer Section Link Click event
  var footerAnchor = document.querySelector('.footer-habitat').getElementsByTagName("a");
  Array.prototype.forEach.call(footerAnchor, function (singletxt) {
    singletxt.addEventListener('click', function (event) {
      var txt = singletxt.textContent;
      window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("CsfInteractedWithFooterLink", { Link: txt }) : '';
    });
  });

  //Submit Contact Form
  formElem.addEventListener("submit", function (e) {
    e.preventDefault();

    if (!HeroSalesContact.validateFields()) {
      return false;
    }

    if (grecaptcha !== "undefined") {
      HeroSalesContact.init();
    }
    return false;
  });

});